import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import IconBoxContainer from "../containers/global/icon-box";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";

const AboutPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="adbaja – À propos" />
                <div className="wrapper">
                    <Header />
                    <PageBanner
                        title="QUI SOMMES NOUS ?"
                        excerpt="ADBAJA est une société qui est spécialisée dans le domaine informatique. On offre à nos clients les matériels informatique (Serveur, Ordinateur, imprimantes, scanners, Caméra de sécurité...) et bureautiques.Ainsi que les services de maintenance et de la réparation électriques"
                        image="./images/banner/1.png"
                    />
                    <IconBoxContainer classOption="section-pt" />
                    <NewsletterArea />
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default AboutPage;
